import { Link, useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";
import OptimizedImage from "../components/image-optimization/OptimizedImage";
import { Room } from "../components/RoomCard";

const RoomItem: React.FC<Room> = ({ image, name, price, link }) => {
  const { t: tRooms } = useTranslation();

  return (
    <div className="col-md-6  ">
      <div className="item">
        <div className="position-re o-hidden" style={{ height: "300px" }}>
          <OptimizedImage
            src={image}
            alt={name}
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
        <span className="category">
          <Link
            to={link}
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            {tRooms("similarRooms.button.book")}
          </Link>
        </span>
        <div className="con">
          {price && (
            <h6>
              <Link
                to={link}
                placeholder={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              >
                {price}
              </Link>
            </h6>
          )}
          <h5>
            <Link
              to={link}
              placeholder={undefined}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            >
              {name}
            </Link>
          </h5>
          <div className="line"></div>
          <div className="row facilities">
            <div className="col col-md-7">
              <ul>
                <li>
                  <i className="flaticon-bed"></i>
                </li>
                <li>
                  <i className="flaticon-bath"></i>
                </li>
                <li>
                  <i className="flaticon-breakfast"></i>
                </li>
                <li>
                  <i className="flaticon-towel"></i>
                </li>
              </ul>
            </div>
            <div className="col col-md-5 text-end">
              <div className="permalink">
                <Link
                  to={link}
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                >
                  {tRooms("similarRooms.button.details")}{" "}
                  <i className="ti-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export type RoomsSectionProps = {
  title: string;
  subtitle: string;
  items: Room[];
};

const RoomsSection: React.FC<RoomsSectionProps> = ({
  title,
  subtitle,
  items,
}) => {
  return (
    <section className="rooms1 section-padding bg-cream" data-scroll-index="1">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-subtitle">{subtitle}</div>
            <div className="section-title">{title}</div>
          </div>
        </div>
        <div className="row">
          {items.slice(0, 2).map((item, index) => (
            <RoomItem
              key={index}
              {...item}
            />
          ))}
        </div>
        <div className="row">
          {items.slice(2, 4).map((item, index) => (
            <RoomItem
              key={index}
              {...item}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoomsSection;
